import { Text, Button, Center, Flex, Select, TextInput, MultiSelect } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import React from "react";
import { useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { useRecoilState } from "recoil";
import { groupListState } from "components/Form/atom/groupListState";
import { popupUserListState } from "components/Form/atom/popupUserListState";

import { getPopupUser } from "pages/Admin/User/apis/adminUserApis";
import { deleteSite, getSite, updateSite } from "../apis/adminSiteApis";
import { getPathname } from "utils/getPathname";
import Post from "components/Post";

function SiteEditForm() {
  const fieldId = getPathname();
  const navigate = useNavigate();

  useEffect(() => {
    getSite(fieldId).then((res) => {
      const { users, users_nm } = res;
      setDefaultValues({
        ...res,
        users: users
          ?.trim()
          .split(",")
          .map((item) => item.trim()),
        users_nm: users_nm
          ?.trim()
          .split(",")
          .map((item) => item.trim()),
      });
    });
  }, []);

  const location = useLocation();
  let backPage = 1;
  if (location.state) {
    backPage = location.state.pg;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    navigate(`/admin/site?${params.toString()}`, {replace: true});
  };

  const [defaultValues, setDefaultValues] = useState();
  const [selectGroupId, setSelectGroupId] = useState();

  const [showPostModal, setShowPostModal] = useState(false);
  const [postResult, setPostResult] = useState();
  const [detailAddress, setDetailAddress] = useState();

  const [popupUserList, setPopupUserList] = useRecoilState(popupUserListState);

  useEffect(() => {
    if (selectGroupId) {
      getPopupUser(selectGroupId).then((res) =>
        setPopupUserList(
          res.map((item) => ({
            value: item.user_id,
            label: item.fn_name,
          }))
        )
      );
    }
  }, [selectGroupId]);

  const handleButtonClick = () => {
    setShowPostModal(true);
  };

  const handleModalComplete = (data) => {
    setPostResult(data.address);
    setShowPostModal(false);
  };

  const handleModalCancel = () => {
    setShowPostModal(false);
  };

  const SearchAddress = (props) => {
    const { field, error } = props;

    return (
      <>
        <TextInput
          placeholder="주소"
          label="주소(직접 입력 시 상세주소창에 입력하세요)"
   //       required
          defaultValue={field.value}
          value={postResult}
          onClick={handleButtonClick}
          error={error}
        />
        <TextInput
          placeholder="상세 주소"
   //       disabled={postResult ? false : true}
          value={detailAddress}
          onChange={field.onChange}
        />
      </>
    );
  };

  const GroupSelect = (props) => {
    const { field, error } = props;

    const [groupList, setGroupList] = useRecoilState(groupListState);
    if (field.value !== undefined) setSelectGroupId(field.value);

    return (
      <>
        <Select
          label="그룹"
          required
          data={groupList}
          value={field.value}
          onChange={field.onChange}
          error={error}
        />
      </>
    );
  };

  const SiteManagerSelect = (props) => {
    const { field, name } = props;

    return (
      <>
        <MultiSelect
          label={name}
          data={popupUserList}
          defaultValue={field.value}
          value={field.value}
          onChange={field.onChange}
        />
      </>
    );
  };

  const fields = [
    {
      key: "group_id",
      name: "그룹",
      type: "etc",
      component: GroupSelect,
      options: "validate",
    },
    {
      key: "field_nm",
      name: "현장명",
      type: "text",
      options: "validate",
    },
    {
      key: "address",
      name: "주소",
      type: "etc",
      component: (props) => <SearchAddress {...props} />,
    },
    {
      key: "office_phone",
      name: "현장 연락처",
      type: "text",
      options: "validate",
    },
    {
      key: "users",
      name: "현장 담당자",
      type: "etc",
      component: SiteManagerSelect,
    },
    {
      key: "etc",
      name: "비고",
      type: "text",
    },
  ];

  const onSubmit = (e) => {
    const { users } = e;
    const multiSelectUsers = popupUserList.filter((popupUser) => {
      return users?.indexOf(popupUser.value) !== -1;
    });

    const updateUsers = multiSelectUsers.map((user) => user.value).join(",");
    const updateUserName = multiSelectUsers.map((user) => user.label).join(",");

    const data = { ...e, users: updateUsers, users_nm: updateUserName, field_id: fieldId };

    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        updateSite(data, postResult);
        backToList();
      },
    });
  };

  const onDelete = () => {
    modals.openConfirmModal({
      title: "삭제",
   //   centered: true,
      zIndex: 2000,
      children: (
        <Center>
          <Text>정말 삭제하시겠습니까? (삭제 후 복구불가)</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteSite(fieldId);
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button color="red" onClick={() => onDelete()}>
            삭제
          </Button>
          <Button type="submit">수정</Button>
        </Flex>
      </Center>
    );
  };

  return (
    <>
      <SRD_Form
        fields={fields}
        onSubmit={onSubmit}
        submitButton={<SubmitButton />}
        defaultValues={defaultValues}
      />
      {showPostModal && <Post onComplete={handleModalComplete} onCancel={handleModalCancel} />}
    </>
  );
}

export default SiteEditForm;
